<!-- 分类列表 -->

<template>
  <div class="main" v-loading="loading">
    <!-- 顶部搜索 -->
    <div class="s_wrapper">
      <el-select v-model="project" placeholder="选择项目应用" @change="onSearch" clearable class="s_input">
        <el-option v-for="item in projectOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
      </el-select>
      <el-input class="s_input" placeholder="搜索分类名称" suffix-icon="el-icon-search" v-model="categoryName"
        :clearable="true" @change="onSearch"></el-input>
      <el-button class="btn" type="primary" @click="handleAddOne">新增一级分类</el-button>
    </div>

    <!-- 表格 -->
    <div class="g_table">
      <el-table :data="tableData" style="width: 100%" max-height="540" row-key="categoryId">
        <el-table-column show-overflow-tooltip min-width="120" label="项目应用">
          <template slot-scope="scope">
            <span v-if="scope.row.project == 1">养长福</span>
            <span v-if="scope.row.project == 2">脑健康</span>
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip min-width="120" prop="categoryName" label="分类名称"></el-table-column>
        <el-table-column label="操作" header-align="center" align="center" width="300">
          <template slot-scope="scope">
            <el-button v-if="scope.row.parentCategoryId == 0" class="btn" type="primary" plain
              @click="handleAddTwo(scope.row)">新增二级分类</el-button>
            <el-button class="btn" type="" plain @click="handleEdit(scope.row)">修改</el-button>
            <el-button class="btn" type="danger" plain @click="handleDelete(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 分页 -->
    <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
      :current-page.sync="currentPage" :page-size="pageSize" :page-sizes="pageSizeArr"
      layout="prev, pager, next, jumper, sizes, total" :total="totalItemsCount"></el-pagination>

    <!-- 分类弹窗 -->
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" @close="handleCloseDialog">
      <el-form :model="ruleForm" ref="ruleForm" :rules="rules" class="demo-ruleForm" label-width="150px">
        <el-row>
          <el-col :span="12">
            <el-form-item label="项目应用" prop="project">
              <el-select v-model="ruleForm.project" placeholder="请选择" clearable
                :disabled="isCategoryTwoAdd || isCategoryTwoEdit">
                <el-option label="养长福" :value="1"></el-option>
                <el-option label="脑健康" :value="2"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="二级类目" prop="categoryTwo" v-if="isCategoryTwoAdd || isCategoryTwoEdit">
              <el-input v-model="ruleForm.categoryTwo" placeholder="请输入"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="一级类目" prop="categoryOne">
              <el-input v-model="ruleForm.categoryOne" placeholder="请输入"
                :disabled="isCategoryTwoAdd || isCategoryTwoEdit"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" plain @click="handleCloseDialog">取 消</el-button>
        <el-button type="primary" @click="submitForm('ruleForm')">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
      categoryName: "", // 搜索分类
      project: "",
      projectOptions: [
        {
          value: "1",
          label: "养长福",
        },
        {
          value: "2",
          label: "脑健康",
        },
      ],
      // 表格数据
      tableData: [],
      // 弹窗
      dialogVisible: false,
      dialogTitle: "",
      isCategoryOneAdd: false, // 一级分类新增
      isCategoryOneEdit: false, // 一级分类编辑
      isCategoryTwoAdd: false, // 二级分类新增
      isCategoryTwoEdit: false, // 二级分类编辑
      ruleForm: {
        project: "",
        categoryOne: "",
        categoryTwo: "",
        categoryId: "",
      },
      rules: {
        project: [{
          required: true,
          message: "请选择项目应用",
          trigger: "blur",
        },],
        categoryOne: [{
          required: true,
          message: "请输入一级类目",
          trigger: "blur",
        },],
        categoryTwo: [{
          required: true,
          message: "请输入二级类目",
          trigger: "blur",
        },],
      },
      // 分页
      currentPage: 1, // 当前页码
      pageSize: 10, // 每页显示的行数
      pageSizeArr: [10, 20, 50], // 每页显示的行数(可选)
      totalItemsCount: 0, // 总记录数（需要从后端获取）
    }
  },
  created() {
    // this.getCategoryList()
  },
  methods: {
    // 列表
    getCategoryList() {
      this.loading = true
      this.$axios
        .get(this.$api.getCategoryList, {
          params: {
            categoryName: this.categoryName || null,
            project: this.project || null,
            page: this.currentPage,
            pageSize: this.pageSize,
          },
        })
        .then(res => {
          if (res.code == 100) {
            this.tableData = res.result.list
            this.totalItemsCount = res.result.totalCount
          }
          this.loading = false
        })
        .catch(err => {
          this.loading = false
          this.$message.error(err.desc)
        })
    },
    // 新增一级分类
    handleAddOne() {
      this.dialogTitle = "新增一级分类"
      this.dialogVisible = true
      this.isCategoryOneAdd = true
    },
    // 新增二级分类
    handleAddTwo(row) {
      this.$set(this.ruleForm, "categoryOne", row.categoryName)
      this.$set(this.ruleForm, "project", row.project)
      this.$set(this.ruleForm, "categoryId", row.categoryId)
      this.dialogTitle = "新增二级分类"
      this.dialogVisible = true
      this.isCategoryTwoAdd = true
    },
    // 修改
    handleEdit(row) {
      this.dialogVisible = true
      if (row.parentCategoryId == 0) {
        this.dialogTitle = "修改一级分类"
        this.isCategoryOneEdit = true
        this.$set(this.ruleForm, "categoryOne", row.categoryName)
        this.$set(this.ruleForm, "project", row.project)
        this.$set(this.ruleForm, "categoryId", row.categoryId)
      } else {
        this.dialogTitle = "修改二级分类"
        this.isCategoryTwoEdit = true
        this.$set(this.ruleForm, "categoryOne", row.parentCategoryName)
        this.$set(this.ruleForm, "project", row.project)
        this.$set(this.ruleForm, "categoryTwo", row.categoryName)
        this.$set(this.ruleForm, "categoryId", row.categoryId)
      }
    },
    // 关闭弹窗
    handleCloseDialog() {
      this.dialogVisible = false
      this.dialogTitle = ""
      this.resetForm()
      this.ruleForm = {}
      this.isCategoryOneAdd = false
      this.isCategoryOneEdit = false
      this.isCategoryTwoAdd = false
      this.isCategoryTwoEdit = false
    },
    // 表单校验
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (!valid) {
          console.log("error submit!!")
          return false
        } else {
          // 请求方式
          let requestMethod
          // api
          let apiUrl
          if (this.isCategoryOneAdd || this.isCategoryTwoAdd) {
            apiUrl = this.$api.newAddCategory
            requestMethod = "post"
          } else if (this.isCategoryOneEdit || this.isCategoryTwoEdit) {
            apiUrl = this.$api.newUpdateCategory
            requestMethod = "put"
          }
          // 传参
          let data
          if (this.isCategoryOneAdd) {
            data = {
              categoryName: this.ruleForm.categoryOne,
              project: this.ruleForm.project,
            }
          } else if (this.isCategoryTwoAdd) {
            data = {
              categoryName: this.ruleForm.categoryTwo,
              parentId: this.ruleForm.categoryId,
            }
          } else if (this.isCategoryOneEdit) {
            data = {
              categoryName: this.ruleForm.categoryOne,
              project: this.ruleForm.project,
              categoryId: this.ruleForm.categoryId,
            }
          } else if (this.isCategoryTwoEdit) {
            data = {
              categoryName: this.ruleForm.categoryTwo,
              categoryId: this.ruleForm.categoryId,
            }
          }
          this.$axios[requestMethod](apiUrl, data)
            .then(res => {
              if (res.code == 100) {
                this.$message.success(res.desc)
                this.getCategoryList()
                this.handleCloseDialog()
              }
            })
            .catch(err => {
              this.$message.error(err.desc)
            })
        }
      })
    },
    // 删除
    handleDelete(row) {
      this.$confirm("是否要删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
      })
        .then(() => {
          this.$axios
            .put(`${this.$api.newDeleteCategory}/${row.categoryId}`)
            .then(res => {
              if (res.code == 100) {
                this.$message.success(res.desc)
                this.getCategoryList()
              }
            })
            .catch(err => {
              this.$message.error(err.desc)
            })
        })
        .catch(() => {
          this.$message("取消删除")
        })
    },
    // 默认弹窗设置重置表单
    resetForm() {
      this.$refs.ruleForm.resetFields()
    },
    // 搜索
    onSearch() {
      this.clearData()
      this.getCategoryList()
    },
    // 清空
    clearData() {
      this.tableData = []
      this.currentPage = 1
    },
    // 切换每页显示的条数
    handleSizeChange(e) {
      this.clearData()
      this.pageSize = e
      this.getCategoryList()
    },
    // 换页
    handleCurrentChange(e) {
      this.tableData = []
      this.currentPage = e
      this.getCategoryList()
    },
  },
}
</script>

<style lang="scss" scoped>
.main {}
</style>
